export default {
  FILTER_USER_LIST: 'FilterUserList',
  LOAD_USER_LIST_START: 'LoadUserListStart',
  LOAD_USER_LIST_END: 'LoadUserListEnd',
  LOAD_USER_LIST_USER_STATUSES: 'LoadUserListUserStatuses',
  LOAD_USER_LIST_USER_ROLES: 'LoadUserListUserRoles',
  TOGGLE_USER_CONFIRM_DIALOG: 'ToggleUserConfirmDialog'
};